import { ComponentPropsWithoutRef, ComponentRef, FC, ReactNode, Ref } from 'react';
import classNames from 'classnames';
import { Drawer } from 'vaul';

import { CloseIcon } from '../../../icons';

import styles from './BottomSheetClose.module.css';

export type BottomSheetCloseProps = {
  children?: ReactNode;
  className?: string;
  ref?: Ref<ComponentRef<typeof Drawer.Close>>;
} & Omit<ComponentPropsWithoutRef<typeof Drawer.Close>, 'className'>;

/** Кнопка закрытия шторки. По умолчанию — иконка крестика, заменяется через children. */
const BottomSheetClose: FC<BottomSheetCloseProps> = ({ children, className, ref, ...rest }) => (
  <Drawer.Close
    ref={ref}
    {...rest}
    className={classNames(styles.close, className)}>
    {children ?? <CloseIcon />}
  </Drawer.Close>
);

export default BottomSheetClose;
